import Swal from 'sweetalert2';

// Colores del proyecto
const colors = {
  primary: '#73B0F4',
  success: '#10b981',
  error: '#d95565',
  warning: '#F0AA61',
  info: '#73B0F4',
  purple: '#6363AC',
};

// CSS para animaciones y estilos del modal
const animationStyle = `
  @keyframes scaleIn {
    0% { transform: scale(0.5); opacity: 0; }
    60% { transform: scale(1.05); }
    100% { transform: scale(1); opacity: 1; }
  }
  @keyframes drawLine {
    0% { stroke-dashoffset: 50; }
    100% { stroke-dashoffset: 0; }
  }
  @keyframes fadeInUp {
    0% { opacity: 0; transform: translateY(10px); }
    100% { opacity: 1; transform: translateY(0); }
  }
  .swal-icon-animated {
    animation: scaleIn 0.5s cubic-bezier(0.175, 0.885, 0.32, 1.275) forwards;
  }
  .swal-icon-animated .icon-circle {
    animation: scaleIn 0.4s ease-out forwards;
  }
  .swal-icon-animated .icon-check {
    stroke-dasharray: 50;
    stroke-dashoffset: 50;
    animation: drawLine 0.5s ease-out 0.3s forwards;
  }
  .swal-icon-animated .icon-x {
    stroke-dasharray: 50;
    stroke-dashoffset: 50;
    animation: drawLine 0.4s ease-out 0.3s forwards;
  }

  /* Estilos del modal */
  .swal2-popup.swal2-modal {
    border-radius: 16px !important;
    padding: 1.25rem 1.5rem 1.5rem !important;
    box-shadow: 0 20px 40px -12px rgba(0, 0, 0, 0.12) !important;
  }
  .swal2-title {
    font-size: 1.2rem !important;
    font-weight: 600 !important;
    color: #1f2937 !important;
    margin: 0 !important;
    padding: 0 !important;
  }
  .swal2-html-container {
    font-size: 0.9rem !important;
    color: #6b7280 !important;
    line-height: 1.5 !important;
    margin: 0.5rem 0 0.75rem !important;
    padding: 0 !important;
  }
  .swal2-icon {
    border: none !important;
    margin: 0.75rem auto 0.5rem !important;
    width: auto !important;
    height: auto !important;
  }
  .swal2-actions {
    margin: 0.5rem 0 0 !important;
    padding: 0 !important;
  }
  /* Select/input con la misma tipografia del modal */
  .swal2-select,
  .swal2-input {
    font-family: inherit !important;
    font-size: 0.9rem !important;
    color: #1f2937 !important;
    padding: 0.5rem 0.75rem !important;
    border: 1px solid #d1d5db !important;
    border-radius: 8px !important;
    margin: 0.5rem auto 0 !important;
    min-width: 220px !important;
    background: #fff !important;
    box-shadow: none !important;
  }
  .swal2-select:focus,
  .swal2-input:focus {
    outline: none !important;
    border-color: #73B0F4 !important;
    box-shadow: 0 0 0 3px rgba(115, 176, 244, 0.2) !important;
  }
`;

// Inyectar estilos de animación
if (typeof document !== 'undefined' && !document.getElementById('swal-custom-animations')) {
  const styleSheet = document.createElement('style');
  styleSheet.id = 'swal-custom-animations';
  styleSheet.textContent = animationStyle;
  document.head.appendChild(styleSheet);
}

// Colores tenues para fondos (10% opacidad)
const bgColors = {
  success: 'rgba(16, 185, 129, 0.1)',
  error: 'rgba(217, 85, 101, 0.1)',
  warning: 'rgba(240, 170, 97, 0.1)',
  info: 'rgba(115, 176, 244, 0.1)',
  purple: 'rgba(99, 99, 172, 0.1)',
};

// Iconos SVG elegantes y finos
const icons = {
  success: `
    <div class="swal-icon-animated">
      <svg viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg" style="width: 100px; height: 100px;">
        <circle class="icon-circle" cx="25" cy="25" r="23" fill="${bgColors.success}" stroke="${colors.success}" stroke-width="1.5"/>
        <path class="icon-check" d="M15 26l7 7 13-14" stroke="${colors.success}" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" fill="none"/>
      </svg>
    </div>
  `,
  error: `
    <div class="swal-icon-animated">
      <svg viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg" style="width: 100px; height: 100px;">
        <circle class="icon-circle" cx="25" cy="25" r="23" fill="${bgColors.error}" stroke="${colors.error}" stroke-width="1.5"/>
        <path class="icon-x" d="M17 17l16 16" stroke="${colors.error}" stroke-width="2" stroke-linecap="round"/>
        <path class="icon-x" d="M33 17l-16 16" stroke="${colors.error}" stroke-width="2" stroke-linecap="round"/>
      </svg>
    </div>
  `,
  warning: `
    <div class="swal-icon-animated">
      <svg viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg" style="width: 100px; height: 100px;">
        <path class="icon-circle" d="M25 4L3 46h44L25 4z" fill="${bgColors.warning}" stroke="${colors.warning}" stroke-width="1.5" stroke-linejoin="round"/>
        <path d="M25 18v12" stroke="${colors.warning}" stroke-width="2" stroke-linecap="round"/>
        <circle cx="25" cy="36" r="1.5" fill="${colors.warning}"/>
      </svg>
    </div>
  `,
  info: `
    <div class="swal-icon-animated">
      <svg viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg" style="width: 100px; height: 100px;">
        <circle class="icon-circle" cx="25" cy="25" r="23" fill="${bgColors.info}" stroke="${colors.info}" stroke-width="1.5"/>
        <path d="M25 22v12" stroke="${colors.info}" stroke-width="2" stroke-linecap="round"/>
        <circle cx="25" cy="15" r="1.5" fill="${colors.info}"/>
      </svg>
    </div>
  `,
  question: `
    <div class="swal-icon-animated">
      <svg viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg" style="width: 100px; height: 100px;">
        <circle class="icon-circle" cx="25" cy="25" r="23" fill="${bgColors.purple}" stroke="${colors.purple}" stroke-width="1.5"/>
        <path class="icon-check" d="M19 18a6 6 0 0111 3c0 4-6 5-6 9" stroke="${colors.purple}" stroke-width="2" stroke-linecap="round" fill="none"/>
        <circle cx="25" cy="36" r="1.5" fill="${colors.purple}"/>
      </svg>
    </div>
  `,
  delete: `
    <div class="swal-icon-animated">
      <svg viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg" style="width: 100px; height: 100px;">
        <rect class="icon-circle" x="10" y="14" width="30" height="32" rx="3" fill="${bgColors.error}" stroke="${colors.error}" stroke-width="1.5"/>
        <path d="M8 14h34" stroke="${colors.error}" stroke-width="1.5" stroke-linecap="round"/>
        <path d="M19 14V10a3 3 0 013-3h6a3 3 0 013 3v4" stroke="${colors.error}" stroke-width="1.5"/>
        <path class="icon-x" d="M19 22v16M25 22v16M31 22v16" stroke="${colors.error}" stroke-width="1.5" stroke-linecap="round"/>
      </svg>
    </div>
  `,
};

// Función para generar estilos inline de botón
const createButtonStyle = (bgColor, hoverColor) => `
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 10px 24px;
  font-size: 14px;
  font-weight: 600;
  color: white;
  background-color: ${bgColor};
  border: none;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s ease;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
`;

// Configuración de botones por tipo
const buttonConfigs = {
  success: { bg: colors.success, hover: '#0d9668' },
  error: { bg: colors.error, hover: '#c44455' },
  warning: { bg: colors.warning, hover: '#d99550' },
  info: { bg: colors.info, hover: '#5a9de0' },
  primary: { bg: colors.primary, hover: '#5a9de0' },
  delete: { bg: '#dc2626', hover: '#b91c1c' },
  cancel: { bg: '#e5e7eb', hover: '#d1d5db', textColor: '#374151' },
};

// Función helper para aplicar estilos a botones
function applyButtonStyles(popup, type, hasCancel = false) {
  const confirmBtn = popup.querySelector('.swal2-confirm');
  const cancelBtn = popup.querySelector('.swal2-cancel');
  const config = buttonConfigs[type];

  if (confirmBtn && config) {
    confirmBtn.style.cssText = createButtonStyle(config.bg, config.hover);
    confirmBtn.onmouseenter = () => { confirmBtn.style.backgroundColor = config.hover; };
    confirmBtn.onmouseleave = () => { confirmBtn.style.backgroundColor = config.bg; };
  }

  if (cancelBtn && hasCancel) {
    const cancelConfig = buttonConfigs.cancel;
    cancelBtn.style.cssText = createButtonStyle(cancelConfig.bg, cancelConfig.hover);
    cancelBtn.style.color = cancelConfig.textColor;
    cancelBtn.style.marginLeft = '12px';
    cancelBtn.onmouseenter = () => { cancelBtn.style.backgroundColor = cancelConfig.hover; };
    cancelBtn.onmouseleave = () => { cancelBtn.style.backgroundColor = cancelConfig.bg; };
  }
}

/**
 * Muestra un mensaje de error
 * @param {string} mensaje - Mensaje a mostrar
 * @param {string} titulo - Titulo del modal (opcional)
 */
export function mensajeError(mensaje, titulo = 'Error') {
  return Swal.fire({
    customClass: { icon: 'border-0' },
    buttonsStyling: false,
    title: titulo,
    text: mensaje,
    iconHtml: icons.error,
    confirmButtonText: 'Aceptar',
    didOpen: (popup) => applyButtonStyles(popup, 'error'),
  });
}

/**
 * Muestra un mensaje de error con HTML
 * @param {string} titulo - Titulo del modal
 * @param {string} html - Contenido HTML
 */
export function mensajeErrorHtml(titulo, html) {
  return Swal.fire({
    customClass: { icon: 'border-0' },
    buttonsStyling: false,
    title: titulo,
    html: html,
    iconHtml: icons.error,
    confirmButtonText: 'Aceptar',
    didOpen: (popup) => applyButtonStyles(popup, 'error'),
  });
}

/**
 * Muestra un mensaje de exito/correcto
 * @param {string} mensaje - Mensaje a mostrar
 * @param {string} titulo - Titulo del modal (opcional)
 */
export function mensajeCorrecto(mensaje, titulo = 'Correcto') {
  return Swal.fire({
    customClass: { icon: 'border-0' },
    buttonsStyling: false,
    title: titulo,
    text: mensaje,
    iconHtml: icons.success,
    confirmButtonText: 'Aceptar',
    didOpen: (popup) => applyButtonStyles(popup, 'success'),
  });
}

/**
 * Muestra un mensaje exitoso
 * @param {string} mensaje - Mensaje a mostrar
 * @param {string} titulo - Titulo del modal (opcional)
 */
export function mensajeExitoso(mensaje, titulo = 'Exitoso') {
  return Swal.fire({
    customClass: { icon: 'border-0' },
    buttonsStyling: false,
    title: titulo,
    text: mensaje,
    iconHtml: icons.success,
    confirmButtonText: 'Aceptar',
    didOpen: (popup) => applyButtonStyles(popup, 'success'),
  });
}

/**
 * Muestra un mensaje de advertencia
 * @param {string} mensaje - Mensaje a mostrar
 * @param {string} titulo - Titulo del modal (opcional)
 */
export function mensajeAdvertencia(mensaje, titulo = 'Advertencia') {
  return Swal.fire({
    customClass: { icon: 'border-0' },
    buttonsStyling: false,
    title: titulo,
    text: mensaje,
    iconHtml: icons.warning,
    confirmButtonText: 'Aceptar',
    didOpen: (popup) => applyButtonStyles(popup, 'warning'),
  });
}

/**
 * Muestra un mensaje informativo
 * @param {string} mensaje - Mensaje a mostrar
 * @param {string} titulo - Titulo del modal (opcional)
 */
export function mensajeInfo(mensaje, titulo = 'Informacion') {
  return Swal.fire({
    customClass: { icon: 'border-0' },
    buttonsStyling: false,
    title: titulo,
    text: mensaje,
    iconHtml: icons.info,
    confirmButtonText: 'Aceptar',
    didOpen: (popup) => applyButtonStyles(popup, 'info'),
  });
}

/**
 * Muestra un dialogo de confirmacion
 * @param {string} titulo - Titulo del modal
 * @param {string} texto - Texto descriptivo
 * @param {string} confirmText - Texto del boton confirmar (opcional)
 * @param {string} cancelText - Texto del boton cancelar (opcional)
 * @returns {Promise<boolean>} - True si confirmo, false si cancelo
 */
export async function mensajeConfirmacion(titulo, texto, confirmText = 'Si', cancelText = 'No') {
  const result = await Swal.fire({
    customClass: { icon: 'border-0' },
    buttonsStyling: false,
    title: titulo,
    text: texto,
    iconHtml: icons.question,
    showCancelButton: true,
    confirmButtonText: confirmText,
    cancelButtonText: cancelText,
    didOpen: (popup) => applyButtonStyles(popup, 'primary', true),
  });
  return result.isConfirmed;
}

/**
 * Muestra un dialogo de confirmacion para eliminar
 * @param {string} nombreElemento - Nombre del elemento a eliminar
 * @returns {Promise<boolean>} - True si confirmo, false si cancelo
 */
export async function mensajeConfirmacionEliminar(nombreElemento) {
  const result = await Swal.fire({
    customClass: { icon: 'border-0' },
    buttonsStyling: false,
    title: 'Eliminar',
    text: `Esta seguro que desea eliminar ${nombreElemento}?`,
    iconHtml: icons.delete,
    showCancelButton: true,
    confirmButtonText: 'Eliminar',
    cancelButtonText: 'Cancelar',
    didOpen: (popup) => applyButtonStyles(popup, 'delete', true),
  });
  return result.isConfirmed;
}

/**
 * Muestra un dialogo con lista de opciones para seleccionar
 * @param {string} titulo - Titulo del modal
 * @param {string} texto - Texto descriptivo
 * @param {Array<{value: string, label: string}>} opciones - Opciones disponibles
 * @param {string} confirmText - Texto del boton confirmar
 * @param {string} cancelText - Texto del boton cancelar
 * @returns {Promise<string|null>} - Valor seleccionado o null si cancelo
 */
export async function mensajeSeleccion(titulo, texto, opciones, confirmText = 'Confirmar', cancelText = 'Cancelar', iconType = 'warning') {
  const inputOptions = {};
  opciones.forEach(o => { inputOptions[o.value] = o.label; });
  const result = await Swal.fire({
    customClass: { icon: 'border-0' },
    buttonsStyling: false,
    title: titulo,
    text: texto,
    iconHtml: icons[iconType] || icons.warning,
    input: 'select',
    inputOptions,
    inputPlaceholder: 'Seleccione una opción',
    showCancelButton: true,
    confirmButtonText: confirmText,
    cancelButtonText: cancelText,
    inputValidator: (value) => { if (!value) return 'Debe seleccionar una opción'; },
    didOpen: (popup) => applyButtonStyles(popup, 'primary', true),
  });
  return result.isConfirmed ? result.value : null;
}

/**
 * Muestra un toast (notificacion pequeña)
 * @param {string} mensaje - Mensaje a mostrar
 * @param {string} tipo - Tipo: success, error, warning, info
 */
export function toast(mensaje, tipo = 'success') {
  const Toast = Swal.mixin({
    toast: true,
    position: 'top-end',
    showConfirmButton: false,
    timer: 3000,
    timerProgressBar: true,
    didOpen: (toast) => {
      toast.onmouseenter = Swal.stopTimer;
      toast.onmouseleave = Swal.resumeTimer;
    },
  });
  return Toast.fire({
    icon: tipo,
    title: mensaje,
  });
}

// Exportar todas las funciones como un objeto para uso alternativo
const Mensajes = {
  error: mensajeError,
  errorHtml: mensajeErrorHtml,
  correcto: mensajeCorrecto,
  exitoso: mensajeExitoso,
  advertencia: mensajeAdvertencia,
  info: mensajeInfo,
  confirmacion: mensajeConfirmacion,
  confirmarEliminar: mensajeConfirmacionEliminar,
  toast: toast,
};

export default Mensajes;
